import styled from '@emotion/styled';
import { Text } from '../../../components';
import React, { useEffect } from 'react';
import { theme } from '@repo-sapiens/theme';
import { Checkmark, WarningIcon } from '../../../components/icons';
import { extractFromQuery } from '@repo-sapiens/helpers';

export const DONE_MESSAGE = 'done';

const IconWrapper = styled.div`
  align-items: center;
  background: linear-gradient(
    60deg,
    ${theme.colors.accent['blue/main']},
    ${theme.colors.accent['purple/light']},
    ${theme.colors.accent['pink/main']}
  );
  border-radius: 150px;
  display: flex;
  flex-direction: column;
  height: 150px;
  justify-content: center;
  margin-bottom: 40px;
  margin-top: 40px;
  width: 150px;
`;

type QueryParams = {
  error?: string;
};
export const DoneScreen: React.FC = () => {
  // We may end up on this page after a Google OAuth redirect. In the case
  // where that Google OAuth login took place inside of a popup window, we
  // want to close that window. So, we postMessage to a potential parent
  // window.

  const { error } = extractFromQuery<QueryParams>(window.location.search);

  useEffect(() => {
    if (typeof window !== 'undefined' && !error) {
      window.opener?.postMessage(DONE_MESSAGE);
      window.postMessage(DONE_MESSAGE);
      window.parent?.postMessage(DONE_MESSAGE);
    }
  }, [error]);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '20px',
      }}
    >
      {error && (
        <>
          <IconWrapper>
            <WarningIcon
              style={{
                height: '100px',
                width: '100px',
                strokeWidth: '4px',
              }}
            />
          </IconWrapper>
          <Text.H3>Integration failed!</Text.H3>

          <Text.Body style={{ textAlign: 'center' }}>
            {error ??
              'All the required scopes are not provided. Makes sure you check all the boxes during the authentication'}
          </Text.Body>
        </>
      )}
      {!error && (
        <>
          <IconWrapper>
            <Checkmark
              style={{
                height: '100px',
                width: '100px',
                fill: 'red',
                stroke: theme.colors.text['highlight/1'],
                strokeWidth: '4px',
              }}
            />
          </IconWrapper>
          <Text.H3>App installed successfully</Text.H3>

          <Text.Body>You can close this window</Text.Body>
        </>
      )}
    </div>
  );
};
